import { useState } from 'react';

// Read / add to / edit / delete a note in a popup. The parent supplies the
// current note and an onSave(text) that knows how to persist it.
export default function NotesModal({ title, subtitle, note, readOnly, onClose, onSave }) {
  const [text, setText] = useState(note || '');
  const [saving, setSaving] = useState(false);

  async function save() {
    setSaving(true);
    await onSave(text);
    onClose();
  }
  async function clearNote() {
    if (!window.confirm('Delete this note?')) return;
    setSaving(true);
    await onSave('');
    onClose();
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="w-full max-w-lg rounded-xl border border-navy-500 p-6" style={{ backgroundColor: '#142236' }}>
        <div className="flex items-start justify-between mb-3">
          <div>
            <h2 className="text-white font-bold text-lg">📝 Note</h2>
            <p className="text-gray-400 text-xs mt-0.5 font-mono">{title}{subtitle ? ` — ${subtitle}` : ''}</p>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition text-xl leading-none">&times;</button>
        </div>

        {readOnly ? (
          <div className="rounded px-3 py-2 text-sm text-gray-200 whitespace-pre-wrap min-h-[120px] border" style={{ backgroundColor: '#0f1a29', borderColor: '#1e3a5f' }}>
            {note || <span className="text-gray-600 italic">No note.</span>}
          </div>
        ) : (
          <textarea
            autoFocus
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={6}
            placeholder="Add a note…"
            className="w-full rounded px-3 py-2 text-sm text-white placeholder-gray-500 border focus:outline-none resize-y"
            style={{ backgroundColor: '#0f1a29', borderColor: '#1e3a5f' }}
          />
        )}

        <div className="flex gap-3 mt-4">
          {readOnly ? (
            <button onClick={onClose} className="flex-1 py-2 rounded border border-navy-500 text-gray-300 text-sm hover:text-white hover:border-gray-400 transition">Close</button>
          ) : (
            <>
              <button onClick={save} disabled={saving} className="flex-1 bg-gold-500 text-navy-900 py-2 rounded font-bold uppercase tracking-wide text-sm hover:bg-gold-400 disabled:opacity-50 transition">
                {saving ? 'Saving…' : 'Save'}
              </button>
              {note && (
                <button onClick={clearNote} disabled={saving} className="px-4 py-2 rounded border border-red-500/40 text-red-400 text-sm hover:bg-red-500/10 transition">Delete</button>
              )}
              <button onClick={onClose} disabled={saving} className="px-4 py-2 rounded border border-navy-500 text-gray-400 text-sm hover:text-white hover:border-gray-400 transition">Cancel</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
